define(['common/collections/base', 'common/models/commerce_item'], function(BaseCollection, CommerceItem) {
  var CommerceItemCollection = BaseCollection.extend({
    model: CommerceItem,
  });

  return CommerceItemCollection;
});
